import axios from 'axios';
import { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

const AddReason = () => {
    let history = useHistory();
    const [reason, setReason] = useState('');

    const handleSubmit = async e => {
        e.preventDefault();
        await axios.post(`https://nitrous.rt-itservices.co.uk/packererror/addreason`, {
            reason: reason
        })
            .then(res => {
                alert(res.data);
                history.push("/admin/error_tracking/panel");
            })
            .catch(e => console.log(e))
    }

    return (
        <form className="add-form" onSubmit={handleSubmit}>
            <h4 className="text-center text-light mb-4">Add Error Reason</h4>
            <div className="form-group">
                <small className="form-text text-light">Reason</small>
                <input type="text" name="reason" className="form-control" onChange={e => setReason(e.target.value)} />
            </div>
            <div className="form-group row">
                <button type="submit" className="btn col-6 mx-auto btn-primary add-error-button">Submit</button>
                <Link to="/admin/error_tracking/panel" className="btn col-5 mx-auto btn-primary add-error-button">Back</Link>
            </div>
        </form>
    )
}

export default AddReason